import { ChatCircleDots } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import { FeedbackMessage } from "../feedback";

export function FeedbackSection() {
  return (
    <SectionShell
      id="feedback"
      eyebrow="Feedback"
      eyebrowIcon={ChatCircleDots}
      title="Always kind, always supportive"
      description="Every message speaks like a caring teacher: positive, plain and encouraging. Even warnings and errors are framed as 'let's sort this together' — never harsh, never blaming."
    >
      <Showcase tone="muted">
        <div className="grid gap-4 lg:grid-cols-2">
          <FeedbackMessage variant="success" title="Brilliant work!" message="You finished all 10 questions. That's a new best." />
          <FeedbackMessage variant="encouragement" title="You're getting closer!" message="Mistakes help our brains grow. Want to try that one again?" />
          <FeedbackMessage variant="warning" title="Almost out of time" message="No rush — take a breath and answer when you're ready." />
          <FeedbackMessage variant="error" title="Let's fix this together" message="Something didn't save. Tap retry and we'll give it another go." />
        </div>
      </Showcase>

      <div className="mt-5 rounded-3xl border border-border bg-card p-6 shadow-soft">
        <p className="text-sm font-bold uppercase tracking-wider text-muted-foreground">Words we choose</p>
        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          <p className="rounded-2xl bg-teal/10 p-4 font-semibold text-teal-ink">✓ "Have another go — you've got this."</p>
          <p className="rounded-2xl bg-destructive/10 p-4 font-semibold text-destructive-ink line-through decoration-2">✗ "Wrong. Try again."</p>
        </div>
      </div>
    </SectionShell>
  );
}

export default FeedbackSection;
